<template>
  <div class="card-base card-shadow--small p-20 h-100 ">
    <el-form ref="form" label-width="120px" label-position="top" :inline="true">
      <!-- <el-row :gutter="24">
        <el-col :span="24" :offset="0"> -->
      <!-- buttons -->
      <el-row :gutter="10">
        <el-col :xs="16" :sm="16" :md="16" :lg="5" :xl="5" :offset="0" class="mb-10">
          <el-form-item label="Producto">
            <product-autocomplete-component ref="productAutocomplete" :branchId="document.branch"
              :typeDocument="this.$route.meta.typeDocument" @select="setCode" @clear="code = null" />
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="8" :md="8" :lg="2" :xl="2" :offset="0" class="mb-10">
          <el-form-item label="Precio venta">
            <el-input v-model="price" size="medium" placeholder="$ 0.00" :disabled="disabledLocations">
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="8" :md="8" :lg="4" :xl="4" :offset="0" class="mb-10">
          <el-form-item v-if="this.$route.meta.type === 1">
            <label slot="label">Ubicación: <el-tag size="small" type="info">
                <i class="el-icon-location-information"></i>
                {{ document.codeBranch + '-' + inLocationNumber + '-' +
                  inLocationLetter
                }}
              </el-tag></label>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" :offset="0" class="mb-10">
              <el-input-number v-model="inLocationNumber" @change="changeInputNumber" label="Número" size="medium"
                :min="1" :step="1" :controls="true" controls-position="right">
              </el-input-number>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" :offset="0" class="mb-10">
              <el-input v-model="inLocationLetter" placeholder="Letra" size="medium" maxlength="5" show-word-limit>
              </el-input>
            </el-col>
          </el-form-item>
          <el-form-item v-else>
            <label slot="label">Ubicación:</label>
            <el-select v-model="location" :disabled="disabledLocations" clearable placeholder="Seleccione la ubicación"
              size="medium" value-key="in_location" @change="setMinQuantity" filterable>
              <el-option v-for="item in locations" :key="item.in_location" :label="item.in_location" :value="item">
                <span style="float: left"><i class="el-icon-location-information"></i> {{ item.in_location }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px"><i class="el-icon-receiving"></i> {{
                  item.saldo }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="8" :sm="8" :md="8" :lg="3" :xl="2" :offset="0" class="mb-10">
          <el-form-item label="Cantidad">
            <el-input-number v-model="quantity" label="Cantidad" size="medium" :min="1"
              :max="(this.$route.meta.type === 1) ? 9999 : minQuantity" :step="1" :controls="true"
              controls-position="right">
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :xs="18" :sm="12" :md="12" :lg="7" :xl="7" class="mb-10">
          <el-form-item label="Observación">
            <el-input type="text" placeholder="Observación Transacción" v-model="observation" size="medium" clearable>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="6" :sm="3" :md="3" :lg="3" :xl="3" :offset="0" class="mb-10">
          <el-form-item label="Acciones">
            <el-button :disabled="isDisabled" @click="validateProduct()" type="success" icon="el-icon-plus"
              :loading="loading" size="medium">Agregar</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- detail -->
      <el-divider v-if="isAdmin"/>
      
      <!-- Botones de importación masiva (solo para admin) -->
      <el-row :gutter="10" class="mb-10" v-if="isAdmin">
        <el-col :span="24">
          <el-button 
            type="primary" 
            icon="el-icon-download" 
            size="small"
            @click="downloadTemplate">
            Descargar Plantilla Excel
          </el-button>
          <el-upload
            ref="uploadExcel"
            class="upload-excel-inline"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :data="uploadData"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeUpload"
            :show-file-list="false"
            accept=".xlsx,.xls,.csv"
            :auto-upload="true">
            <el-button 
              type="warning" 
              icon="el-icon-upload2" 
              size="small"
              :loading="uploadLoading"
              :disabled="!canImport">
              Importar desde Excel
            </el-button>
          </el-upload>
        </el-col>
      </el-row>
      
      <el-divider />
      <el-table :data="detail" class="w-100" height="470">
        <el-empty slot="empty" description="No hay datos"></el-empty>
        <el-table-column prop="code" label="Código" min-width="80">
        </el-table-column>
        <el-table-column prop="in_location" label="Ubicación" min-width="100">
        </el-table-column>
        <el-table-column prop="description" label="Descrpción" min-width="250">
        </el-table-column>
        <el-table-column prop="quantity" label="Cantidad" min-width="100" max-width="100">
        </el-table-column>
        <el-table-column prop="sale_price" label="P. Venta" min-width="100" max-width="100">
          <template slot-scope="scope">$ {{ (scope.row.sale_price_edit !== '' && scope.row.sale_price_edit !== null) ? scope.row.sale_price_edit : scope.row.sale_price }}</template>
        </el-table-column>
        <el-table-column prop="observation" label="Observación" min-width="250">
        </el-table-column>
        <el-table-column prop="actioions" label="Acciones" width="100">
          <template slot-scope="scope">
            <el-popconfirm confirm-button-text='Confirmar' cancel-button-text='Cancelar' icon="el-icon-info"
              icon-color="red" title="Confirmar eliminación" @confirm="deleteRow(detail[scope.$index])" v-can="['admin']">
              <el-button slot="reference" type="danger" plain round size="mini" icon="el-icon-delete">
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- </el-col>
      </el-row> -->
    </el-form>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import ProductAutocompleteComponent from '@/views/pages/product/Autocomplete.vue'
import { getLocationsById } from "@/api/product";
import { importExcel, downloadTemplate } from "@/api/inputOutputAdjust";
import { getToken } from "@/utils/auth";
export default {
  components: { ProductAutocompleteComponent },
  data: () => {
    return {
      loading: false,
      disabledLocations: true,
      quantity: 1,
      price: "",
      code: null,
      observation: null,
      minQuantity: 1,
      inLocationNumber: 1,
      inLocationLetter: '',
      location: '',
      branchIdDetail: '',
      locations: [],
      uploadLoading: false,
    };
  },
  watch: {
    inLocationLetter(v) {
      this.inLocationLetter = v.toUpperCase()
    },
    document: {
      deep: true,
      handler(val, oldVal) {
        if (Object.keys(val).length !== 0) {
          this.code = null
          this.disabledLocations = true
          this.quantity = 1
          this.location = ''
        }
      },
    },
  },
  computed: {
    ...mapGetters(['document', 'response', 'detail', 'inventoryAuditId']),
    isAdmin() {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return user && user.email === 'admin@admin.com'
    },
    canImport() {
      return this.document.id || this.$store.state.inputAndOutputAdjust.inventoryAuditId || this.document.branch
    },
    isDisabled() {
      let inLocationLetter = this.inLocationLetter
      if (this.$route.meta.type !== 1) {
        inLocationLetter = this.location
      }
      if (!this.code || inLocationLetter == '') {
        return true
      } else {
        return false
      }
    },
    uploadUrl() {
      return `${process.env.VUE_APP_ROOT_API}/inputOutputAdjust/importExcel`
    },
    uploadHeaders() {
      return {
        'Authorization': `Bearer ${getToken()}` 
      }
    },
    uploadData() {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return {
        document_id: this.document.id,
        inventory_audit_id: this.$store.state.inputAndOutputAdjust.inventoryAuditId,
        branch_id: this.document.branch,
        transaction_type: this.$route.meta.type,
        type_document: this.$route.meta.typeDocument,
        user_id: user ? user.id : null,
        third_id: this.document.thirdId,
        num_days: this.document.numDays,
        observation: this.document.observation,
        document_reference: this.document.document_reference,
        cost_center_id: this.document.costCenterId
      }
    }
  },
  methods: {
    ...mapMutations(['inputAndOutputAdjust/SET_OBSERVATION']),
    ...mapActions([
      'inputAndOutputAdjust/addProductAction',
      'inputAndOutputAdjust/deleteRowAction',
    ]),
    setMinQuantity(item) {
      this.branchIdDetail = item.bodega_id
      this.quantity = 1
      this.minQuantity = parseInt(item.saldo)
    },
    setCode(item) {      
      (item) ? this.price = item.precio_venta : "";
      (item) ? this.code = item.codigo : null;
      if (item && this.$route.meta.typeDocument !== 7) {
        this.getLocationsProductById(item.id);
      }
    },
    getLocationsProductById(id) {
      let me = this
      getLocationsById(id, this.document.branch)
        .then(({ data }) => {
          me.locations = data;
          me.disabledLocations = false
        })
        .catch((e) => {
          console.log(e);
          me.disabledLocations = true
          me.$message.error("Error al traer ubicaciones de producto.");
        });
    },
    validateProduct() {
      if (!this.code)
        return;
      let location = (this.$route.meta.type === 1) ? this.document.codeBranch + '-' + this.inLocationNumber + '-' + this.inLocationLetter : this.location.in_location
      this.loading = true;
      this['inputAndOutputAdjust/addProductAction']({
        code: this.code,
        quantity: this.quantity,
        price: this.price,
        in_location: location,
        observation: this.observation,
        type: this.$route.meta.type,
        typeDocument: this.$route.meta.typeDocument,
        branchId: this.branchIdDetail,
      })
      this.$refs.productAutocomplete.reset()
      // this.$refs.branchAutocomplete.reset()
      this.code = null;
      this.observation = null;
      this.location = null;
      this.inLocationNumber = 1;
      this.inLocationLetter = '';
      this.quantity = 1
      this.price = '';
      this.loading = false;
      this.disabledLocations = true;
    },
    deleteRow(row) {
      this['inputAndOutputAdjust/deleteRowAction'](row)
    },
    changeInputNumber(currentValue, oldValue) {
      if (typeof currentValue == 'undefined') {
        this.inLocationNumber = 1
      }
    },
    downloadTemplate() {
      downloadTemplate()
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'plantilla_importacion_inventario.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error('Error al descargar plantilla:', error)
          this.$message.error('Error al descargar la plantilla')
        })
    },
    beforeUpload(file) {
      const isExcel = /\.(xlsx|xls|csv)$/.test(file.name)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('El archivo debe ser formato Excel (.xlsx, .xls, .csv)')
        return false
      }
      if (!isLt10M) {
        this.$message.error('El tamaño del archivo no puede exceder 10MB')
        return false
      }
      
      // Debug: verificar token
      console.log('Token:', getToken())
      console.log('Headers:', this.uploadHeaders)
      
      this.uploadLoading = true
      return true
    },
    handleUploadSuccess(response, file, fileList) {
      this.uploadLoading = false
      
      if (response.code === 200) {
        const { success_count, error_count, errors, detail, auditory, inventory_audit_id } = response.data
        
        // Actualizar el inventoryAuditId si se creó uno nuevo
        if (inventory_audit_id) {
          this.$store.commit('inputAndOutputAdjust/SET_INVENTORY_AUDIT_ID', inventory_audit_id)
        }
        
        // Actualizar el detalle en el store
        if (auditory) {
          // Si es un ajuste pendiente, usar auditory
          this.$store.commit('inputAndOutputAdjust/SET_DETAIL', auditory)
        } else if (detail) {
          // Si es un documento guardado, usar detail
          this.$store.commit('inputAndOutputAdjust/SET_DETAIL', { detail: detail, id: null })
        }
        
        // Mostrar mensaje de éxito
        let message = `Importación completada: ${success_count} productos agregados`
        if (error_count > 0) {
          message += `, ${error_count} errores`
        }
        
        this.$message({
          type: error_count > 0 ? 'warning' : 'success',
          message: message,
          duration: 5000
        })
        
        // Mostrar errores si existen
        if (errors && errors.length > 0) {
          this.showImportErrors(errors)
        }
      } else {
        this.$message.error(response.message || 'Error al importar archivo')
      }
    },
    handleUploadError(err, file, fileList) {
      this.uploadLoading = false
      console.error('Error al subir archivo:', err)
      this.$message.error('Error al importar archivo. Por favor intente nuevamente.')
    },
    showImportErrors(errors) {
      const errorList = errors.map(e => `Fila ${e.row}: ${e.error}`).join('<br>')
      
      this.$notify({
        title: 'Errores de Importación',
        dangerouslyUseHTMLString: true,
        message: `<div style="max-height: 300px; overflow-y: auto;">${errorList}</div>`,
        type: 'warning',
        duration: 10000,
        position: 'bottom-right'
      })
    }
  },
};
</script>

<style scoped>
.el-input-number {
  width: 100%;
}

.upload-excel-inline {
  display: inline-block;
  margin-left: 10px;
}

.upload-excel-inline >>> .el-upload {
  display: inline-block;
}
</style>